"use client";
import { DatePicker } from "antd";
import type { DatePickerProps } from "antd";
import dayjs from 'dayjs'

function AppDatePicker(props: DatePickerProps) {
  // Convert value to dayjs if it's not already a valid dayjs object
  let validValue = props.value;

  if (props.value) {
    // Handle array values (for range pickers)
    if (Array.isArray(props.value)) {
      const converted = props.value
        .map(v => {
          if (dayjs.isDayjs(v)) return v;
          const d = dayjs(v);
          return d.isValid() ? d : null;
        })
        .filter((v): v is dayjs.Dayjs => v !== null);
      validValue = converted.length > 0 ? converted : undefined;
    }
    // Handle single date values
    else if (!dayjs.isDayjs(props.value)) {
      const converted = dayjs(props.value as any);
      validValue = converted.isValid() ? converted : undefined;
    }
  }

  return (
    <DatePicker 
      format="YYYY-MM-DD"
      {...props}
      value={validValue}
    />
  );
}

export { AppDatePicker };
